import {useAppSelector} from 'store/hooks';
import {selectMetadataEditNewExpressionIds} from '../metadataEditSlice';

export const useMetadataHasNewExpressions = (): boolean => {
  const newExpressionIds = useAppSelector(selectMetadataEditNewExpressionIds);

  return newExpressionIds && newExpressionIds.length > 0;
};
